import React, {useState, useEffect, useCallback, useRef} from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { userStore } from '../../../store/UserStore';
import CustomerOnboardingHttp from '../services/customer.service';
import infoIco from 'assets/images/i-circle.svg';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import {toast} from "react-toastify";
import { useHistory } from 'react-router-dom';

interface PropsType {
  customerId:any,
}

const SubAccountCreatePage: React.FC<PropsType> = ({customerId}) => {
  
  const [loading, setLoading] = useState<any>(false);
  const history = useHistory();
  const [user, setUser, customer] = userStore((state: any) => [
    state.user,
    state.setUser,
    state.customer,
  ]);
//const { values } = useFormikContext();

// useEffect(() => {
//   // set the value of textC, based on textA and textB
//   console.log(values);
  
// }, [values]);


const createSubAccount = async (val : any) => {
  setLoading(true);
  try {

    const  account_data = {
      customerId : customerId,
      displayName : val.name
    };
    const acc_res: any = await CustomerOnboardingHttp.createAccount(account_data,user?.userId);
    history.push('/customers');
    setLoading(false);

  } catch (e: any) {
    toast.error(e.data.errors[0].title);
    console.log(e.data);
    setLoading(false);
  }
}

return (
    <>
      
      <div>
        <div className="row justify-content-md-center">
          <div className="col-md-6 col-md-offset-3">
            <Card>
              <Card.Body className="p-5 pb-0">
                <div>
                  <div className="text-center mb-3">
                    <Card.Title>Create New Customer Account</Card.Title>
                    <Card.Subtitle>Setup your account and start your bullion journey today</Card.Subtitle>
                  </div>
                  
                    <Formik
                    enableReinitialize={false}
                    initialValues={{ name: ''}}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      setSubmitting(false);
                      createSubAccount(values);
                      resetForm({
                        values: {
                          // the type of `values` inferred to be Blog
                          name: values.name
                        },
                        // you can also set the other form states here
                      });
                    }}
                    validationSchema={Yup.object().shape({
                      name: Yup.string()
                        .required('Account Name is required')
                    })}
                  >
                    {({ isSubmitting, errors, touched, handleChange, handleBlur }) => (
                      <Form translate={undefined}>
                        <div className="form-group mb-2">
                          <label className="form-label">Account Name</label>
                          <Field type="text" placeholder="" name="name" className="form-control"/>
                          <div className='error'>
                            {errors.name && touched.name && (
                            <small
                              id="my-helper-text"
                            >
                              <img src={infoIco} alt="" />{errors.name}
                            </small>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="form-group mt-2 mb-4">
                            
                            <Button  disabled={loading} variant="primary" className="w-100" size="lg"
                                type="submit"
                              >
                                {!loading ? ('Create Customer') : 
                                  (
                                      <div className="spinner-border text-white" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                  </div>
                                  )}
                                
                              </Button>
                          </div>
                        </div>
                      </Form>
                    )}
                    </Formik>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubAccountCreatePage;
